import * as React from 'react';
import { ILoadingState } from '../hooks/useLoadingState';
import { UIError } from './UIError';
import UIFlex from './UIFlex';
import { UILoadingBox } from './UILoadingBox';
import UILoadingIcon from './UILoadingIcon';

export interface IUILoadingStateProps extends React.PropsWithChildren, ILoadingState{
    
}

export function UILoadingState ($props: IUILoadingStateProps) {
    return (
        <>
            {$props.loading && (
                <UILoadingBox/>
            )}    
            {$props.error && (
                <UIError error={$props.error}/>
            )}
            {(!$props.loading && !$props.error) && $props.children}
        </>
    );
}
